import { render } from "./pcPortal.vue?vue&type=template&id=2abf7b60&ts=true"
import script from "./pcPortal.vue?vue&type=script&lang=ts"
export * from "./pcPortal.vue?vue&type=script&lang=ts"

import "./pcPortal.vue?vue&type=style&index=0&id=2abf7b60&lang=scss"

import exportComponent from "/home/ssh/jigoucode/jigou_fe_v5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__